export const DISABLED_PAYMENTS_TITLE = 'Cobros deshabilitados';
export const DISABLED_PAYMENTS_DESCRIPTION =
  'Por el momento no puedes generar cobros. Acude a tu ejecutivo de cuenta para más información.';
